import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { appRoute } from '../../router/parents';
import { IntakeFormBuilderPage } from './work/form-builder';
import { IntakeFormsPage } from './work/intake-forms';
import { IntakeDetailPage, IntakesPage } from './work/intakes';
import { MatterDetailPage } from './work/matter-detail';
import { MattersPage } from './work/matters';
import { UpdatesPage } from './work/updates';

export const workRoutes: AnyRoute[] = [
  createRoute({ getParentRoute: () => appRoute, path: '/intakes', component: IntakesPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/intakes/$id', component: IntakeDetailPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/intake-forms', component: IntakeFormsPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/intake-forms/$id', component: IntakeFormBuilderPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/matters', component: MattersPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/matters/$id', component: MatterDetailPage }),
  createRoute({ getParentRoute: () => appRoute, path: '/updates', component: UpdatesPage }),
];
